import "./Project.css";
import ProjectCard from "./ProjectCard";
const Projects = () => {
  return (
    <div id="project" className=" mt-4">
      <h1 className="fw-bold text-center" data-aos="fade-down">
        I&apos;ve Built
      </h1>
      <div className="text-center">
        <small>
          The backend response for some projects may not work since only the
          client-side is deployed.
        </small>
      </div>
      <div className="container">
        <div className="row mx-auto w-100 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 ">
          <ProjectCard />
        </div>
      </div>
    </div>
  );
};

export default Projects;
